﻿(function () {

    'use strict';
    var serviceId = 'repository.equipmentstock';
    angular
        .module('app.services')
        .factory(serviceId, equipmentStock);

    equipmentStock.$inject = ['common', 'repository.abstract', '$http'];

    function equipmentStock(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierByName = getCarrierByName;
            this.exportProgressDepotOrder = exportProgressDepotOrder;
            this.getEquipmentStock = getEquipmentStock;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters(currentRoleCode)
        {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetEquipmentStockFilters?criteria=' + currentRoleCode);
        }

        function getCarrierByName(carrierName)
        {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierByName?criteria=' + carrierName);
        }

        function exportProgressDepotOrder(model)
        {
            var result = common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/exportProgressDepotOrder', model);
            return result;
        }

        function getEquipmentStock(model) {
            var result = common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetEquipmentStock', model);
            return result;
        }

    }

})();
